import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';

import { KnmActEventItemBodyProtocolFile } from './KnmActEventItemBodyProtocolFile/KnmActEventItemBodyProtocolFile';
import { KnmActEventItemBodyProtocolsAppendicesToTheProtocolOfAction } from './KnmActEventItemBodyProtocolsAppendicesToTheProtocolOfAction';
import { KnmActEventItemBodyProtocolsStudiedDocuments } from './KnmActEventItemBodyProtocolsStudiedDocuments';
import { IKnmErknmFormEventProtocol } from '../../../../KnmErknmPackage/MainModule/interfaces/IKnmErknmFormEventProtocol';

interface IErknmActEventItemBodyProtocolsProps {
  actIndex?: number;
  attachmentsNumber: number;
  eventFieldValueWithoutAction: boolean;
  eventId: string;
  eventIndex: number;
  formRef: IKnmFormRef | IDecisionFormRef | undefined;
  isDecision?: boolean;
  isPm?: boolean;
  isRequestForDocuments: boolean;
  name: string;
  protocolValue: IKnmErknmFormEventProtocol;
  watchOnly: boolean;
}

export const KnmActEventItemBodyProtocol = ({
  actIndex,
  attachmentsNumber,
  eventFieldValueWithoutAction,
  eventId,
  eventIndex,
  formRef,
  isDecision,
  isPm,
  isRequestForDocuments,
  name,
  protocolValue,
  watchOnly,
}: IErknmActEventItemBodyProtocolsProps) => {
  return (
    <>
      {!eventFieldValueWithoutAction && (
        <KnmActEventItemBodyProtocolFile
          actIndex={actIndex}
          name={`${name}.file.attachments`}
          isDecision={isDecision}
          isPm={isPm}
          eventIndex={eventIndex}
          formRef={formRef}
          isWatchOnly={watchOnly}
          attachmentsNumber={attachmentsNumber}
          eventId={eventId}
        />
      )}
      <KnmActEventItemBodyProtocolsAppendicesToTheProtocolOfAction
        eventId={eventId}
        name={`${name}.appendicesToTheProtocolOfAction`}
        watchOnly={watchOnly}
        isDecision={isDecision}
      />
      {isRequestForDocuments && protocolValue.studiedDocuments && (
        <KnmActEventItemBodyProtocolsStudiedDocuments
          eventId={eventId}
          name={`${name}.studiedDocuments`}
          studiedDocumentsValue={protocolValue.studiedDocuments}
          isDecision={isDecision}
        />
      )}
    </>
  );
};
